// extracted by mini-css-extract-plugin
export default {"grid":"FlexGrid_grid__2bEql","label":"FlexGrid_label__frmOw","value":"FlexGrid_value__sl8Qv"};